import { useMediaQuery, useTheme } from '@mui/material';

/**
 * Is this the phone layout?
 *
 * A width, not a device. The app has three layouts, and this is the boundary
 * of the newest one:
 *
 *   under 600px  — the phone layout: a bottom sheet for filtering, cards that
 *                  are swiped rather than clicked, no sidebars anywhere.
 *   600–900px    — the older narrow layout, which is what an iPad in portrait
 *                  has always had and still gets.
 *   900px and up — the full two-pane desktop.
 *
 * Width rather than `useIsPhone` deliberately. That hook answers "is this a
 * phone", which is the right question for a one-time notice and the wrong one
 * for a layout: a layout has to answer for a window, and a window can be any
 * size on any device. This is also checkable — narrow a desktop browser and
 * you get exactly what a phone gets, which is what makes the phone layout
 * something we can keep working on.
 */
export function useIsMobile(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
}
